import React, { useState, useEffect } from 'react';
import { Modal, FormField, ActionBtn } from './UI';
import { EMPLOYEE_ROLES } from '../../utils/statusHelpers';
import toast from 'react-hot-toast';
import API from '../../utils/api';

const initialForm = { name: '', role: 'Editor', phone: '', email: '', salary: '', salaryType: 'Monthly', status: 'Active', notes: '' };

export default function EmployeeModal({ isOpen, onClose, onSuccess, editItem = null }) {
  const [form, setForm] = useState(initialForm);
  const [saving, setSaving] = useState(false);

  // ✅ وقتی editItem تغییر کرد، فرم را پر کن
  useEffect(() => {
    if (editItem) {
      setForm({
        name: editItem.name || '',
        role: editItem.role || 'Editor',
        phone: editItem.phone || '',
        email: editItem.email || '',
        salary: editItem.salary || '',
        salaryType: editItem.salaryType || 'Monthly',
        status: editItem.status || 'Active',
        notes: editItem.notes || ''
      });
    } else {
      setForm(initialForm);
    }
  }, [editItem]);

  const handleSave = async () => {
    if (!form.name || !form.phone) return toast.error('نام و شماره تلفن ضروری است');
    setSaving(true);
    try {
      let data;
      if (editItem) {
        await API.put(`/employees/${editItem._id}`, form);
        toast.success('کارمند بروزرسانی شد');
      } else {
        const res = await API.post('/employees', form);
        data = res.data;
        toast.success('کارمند اضافه شد');
      }
      setForm(initialForm);
      if (onSuccess) onSuccess(data);
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.message || 'خطا');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={editItem ? 'ویرایش کارمند' : 'کارمند جدید'} size="md">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormField label="نام" required>
          <input className="form-input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="نام کارمند" />
        </FormField>
        <FormField label="نقش" required>
          <select className="form-input" value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
            {Object.entries(EMPLOYEE_ROLES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </FormField>
        <FormField label="شماره تلفن" required>
          <input className="form-input" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="07xx-xxx-xxxx" />
        </FormField>
        <FormField label="ایمیل">
          <input type="email" className="form-input" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="email@example.com" />
        </FormField>
        <FormField label="معاش (افغانی)">
          <input type="number" className="form-input" value={form.salary} onChange={e => setForm({ ...form, salary: e.target.value })} placeholder="0" />
        </FormField>
        <FormField label="نوع معاش">
          <select className="form-input" value={form.salaryType} onChange={e => setForm({ ...form, salaryType: e.target.value })}>
            <option value="Monthly">ماهانه</option>
            <option value="PerProject">هر پروژه</option>
            <option value="Hourly">ساعتی</option>
          </select>
        </FormField>
        <FormField label="وضعیت">
          <select className="form-input" value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
            <option value="Active">فعال</option>
            <option value="Freelance">فریلنس</option>
            <option value="Inactive">غیرفعال</option>
          </select>
        </FormField>
        <div className="sm:col-span-2">
          <FormField label="یادداشت">
            <textarea className="form-input h-20 resize-none" value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} />
          </FormField>
        </div>
      </div>
      <div className="flex gap-3 justify-end mt-6 pt-4 border-t border-gray-200">
        <button onClick={onClose} className="px-5 py-2.5 rounded-xl bg-gray-100 text-gray-800 hover:bg-gray-200 transition-colors text-sm">انصراف</button>
        <ActionBtn onClick={handleSave} label={saving ? 'ذخیره...' : editItem ? 'بروزرسانی' : 'ذخیره'} disabled={saving} />
      </div>
    </Modal>
  );
}